import { Accordion, AccordionDetail, AccordionHeader, AccordionItem, AccordionTitle } from "@vds/accordions";
import { Icon } from "@vds/icons";
import { DropdownSelect } from "@vds/selects";
import { arrangeAsAlphabeticalOrder, extractNameFromFullWidgetName, processUnmatchedTagMatches, deploymentstatusList} from "../../../../global/utility/statisticsUtil";
import { useStatisticContext } from "../../contexts/StatisticContext";
import { STATISTICS_TEST_IDS } from "../../statisticsConstants";

const AppSelection = () => {
  const {
    activeAppNameAccordion,
    setActiveAppNameAccordion,
    appName,
    setAppName,
    appNameToggleDropdown,
    setAppNameToggleDropdown,
    setAppNameForViewTag,
    cvappNameList,
    dataliter,
    getColorsListAsPerSelectedCvApp,
    getObjectListAsPerSelectedCvApp,
    setLocationsWithRoiCvapps,
    roiListItem,
    roisListWithApps,
    setSelectedAreas,
    setSelectedAreaId,
    setSelectedFloorId,
    setSelectedFloors,
    setSelectedSite,
    setSelectedSubAreas,
    setSelectLowerClothingColors,
    setSelectUpperClothingColors,
    setSiteNameForViewTag,
    siteList,
    state,
    setSelectedEventAppObject,
    setFilterList,
    siteReducer,
    mapRoiListBasedOnSites,
    setAccordionSiteOpened,
    pendingAppChange
  } = useStatisticContext();

  const toggleAppNameAccordion = (index, e) => {
    setAppNameToggleDropdown(activeAppNameAccordion === index ? false : true);
    setActiveAppNameAccordion(activeAppNameAccordion === index ? null : index);
  };

  const allAppArray = cvappNameList;

  const handleAppNameChange = (e) => {
    pendingAppChange.current = true;
    setAccordionSiteOpened(null);
    setSelectedFloors([]);
    setSelectedAreas([]);
    setSelectedSubAreas([]);
    setSelectUpperClothingColors([]);
    setSelectLowerClothingColors([]);
    setSelectedEventAppObject("");
    setFilterList((prev) => {
      if ("Object" in prev) {
        const { Object, ...rest } = prev;
        return rest;
      }
      return prev;
    });
     const roiTagObject = processUnmatchedTagMatches(
      mapRoiListBasedOnSites,
      roisListWithApps,
      extractNameFromFullWidgetName(e.target.options[e.target.selectedIndex].text),
      siteReducer,
    );
    setSelectedSite(roiTagObject?.site ?? []);
    setSiteNameForViewTag(roiTagObject?.site[0]?.name ?? "");
    setSelectedFloors(roiTagObject?.floors ?? []);
    setSelectedAreas(roiTagObject?.areas ?? []);
    setSelectedSubAreas(roiTagObject?.subareas ?? []);
    if (state !== null) {
      // state.site = undefined;
      state.floor = undefined;
      state.area = undefined;
      state.subarea = undefined;
      state.allFloors = undefined;
      state.allAreas = undefined;
      state.allSubAreas = undefined;
    }
    const roilistAppname = roiListItem.filter((l) => {
      return (
        l.cvapps !== undefined &&
        Array.isArray(l.cvapps) &&
        l.cvapps.length > 0 &&
        l.cvapps[0].resources?.displayName.indexOf(e.target.value.split("_")[0]) > -1 &&
        l.deployments != undefined &&
        Array.isArray(l.deployments) &&
        l.deployments.length > 0 &&
        deploymentstatusList.includes(l.deployments[0].status)
      );
    });
    const g = dataliter(roilistAppname);
    setLocationsWithRoiCvapps(g);

    setSelectedFloorId("All Floor");
    setSelectedAreaId("All Area");
    if (cvappNameList.indexOf(e.target.value.split("_")[0]) > -1) {
      getObjectListAsPerSelectedCvApp(e.target.value);
      getColorsListAsPerSelectedCvApp(e.target.value);
    }

    setAppName(e.target.options[e.target.selectedIndex].text);
    setAppNameForViewTag(extractNameFromFullWidgetName(e.target.options[e.target.selectedIndex].text));
  };

  const handleAppNameClick = (e) => {
    toggleAppNameAccordion(2, e);
    setAppNameToggleDropdown(true);
  };

  return (
    <>
      <div className="filterTowerItemSeparator"></div>
      <div className="filterTowerItems">
        <div className="statisticsAccordion">
          <Accordion>
            <AccordionItem opened={activeAppNameAccordion === 2} style={{ fontSize: "16px", width: "90%" }}>
              <AccordionHeader
                triggerType="icon"
                style={{
                  height: "20px",
                  width: "20px",
                  top: "8px"
                }}
                data-testid={STATISTICS_TEST_IDS.ACCORDION_HEADER_APPEARANCE}
                onClick={(e) => handleAppNameClick(e)}
              >
                <AccordionTitle>
                  <div className="flexColumn">
                    <div className="flexRow">
                      <span style={{ paddingRight: "10px" }}>
                        <Icon name="wireless-video-surveillance" />
                      </span>
                      <p
                        style={{
                          fontWeight: "100",
                          margin: "0",
                          lineHeight: "27px"
                        }}
                        size="small"
                      >
                        App
                      </p>
                    </div>
                    {activeAppNameAccordion !== 2 && (
                      <div className="filterSelectedVal">
                        Selected : <span> {appName} </span>
                      </div>
                    )}
                  </div>
                </AccordionTitle>
              </AccordionHeader>
              <AccordionDetail>
                {appNameToggleDropdown && (
                  <DropdownSelect
                    style={{ fontSize: "16px" }}
                    width="90%"
                    label="App"
                    errorText="Select a App"
                    error={false}
                    disabled={false}
                    readOnly={false}
                    inlineLabel={false}
                    onChange={(e) => handleAppNameChange(e)}
                    value={appName}
                  >
                    {arrangeAsAlphabeticalOrder(allAppArray).map((f) => {
                      return <option key={f} value={f}>{f}</option>;
                    })}
                  </DropdownSelect>
                )}
              </AccordionDetail>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default AppSelection;
